import { TRUSTED_EMAIL_INPUT_VARIANT_NEUTRAL } from 'mailup-web-components'
import { atomFamily } from 'recoil'

export const trustedEmailSenderState = atomFamily({
  key: 'trustedEmailSenderState',
  default: {
    value: '',
    isError: false,
    isDirty: false,
    invalidRequired: false,
    invalidFormat: false,
    variant: TRUSTED_EMAIL_INPUT_VARIANT_NEUTRAL,
    status: undefined,
    pollingError: false,
    pollingIteration: 0
  }
})
